import { render, staticRenderFns } from "./orderControlDetails.vue?vue&type=template&id=da1aa82a&scoped=true"
import script from "./orderControlDetails.vue?vue&type=script&lang=js"
export * from "./orderControlDetails.vue?vue&type=script&lang=js"
import style0 from "./orderControlDetails.vue?vue&type=style&index=0&id=da1aa82a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1aa82a",
  null
  
)

export default component.exports